import React from 'react';
import { Avatar } from '@mui/material';

const CustomAvatar = ({
  firstName = '',
  lastName = '',
  size = 36,
  backgroundColor = 'var(--primary-color)',
  fallback = 'UA',
  showTitle = true,
}) => {
  const title = `${firstName} ${lastName}`.trim();

  const getInitials = () => {
    if (firstName && lastName) {
      return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
    }
    if (firstName) {
      return firstName[0].toUpperCase();
    }
    return fallback;
  };

  return (
    <Avatar
      title={showTitle ? title : undefined}
      sx={{
        width: size,
        height: size,
        fontSize: size / 2.5,
        backgroundColor: backgroundColor,
      }}>
      {getInitials()}
    </Avatar>
  );
};

export default CustomAvatar;
